import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import { Typography } from 'components/AORedesign';

// Bold value inside a sentence built from flex items; the 8px side padding is the gap between the pieces
const BoldInlineText = ({ children }) => (
  <Box px={1} display="inline">
    <Typography style={{ fontWeight: 800 }}>{children}</Typography>
  </Box>
);

BoldInlineText.propTypes = {
  children: PropTypes.node,
};

export default BoldInlineText;
